(function ($) {

    $(document).ready(function () {

        if ($('.wrapper-personal-bio').length) {

            $(window).on('resize', function(){
                if($('.info-block.active').length){
                    setPopupPosition($('.info-block.active'));
                }
            });

            $(".info-block").live('click',function () {
                $('.info-block.active').removeClass('active');
                setPopupPosition($(this));
            });


            $(".popup .close").on('click', function () {
                $(this).parent('.popup').fadeOut(300);
                $('.info-block.active').removeClass('active');
            });


            function setPopupPosition($this){
                $this.addClass('active');
                var popup = $this.data('popup'),

                    his_popup = $this.closest('.wrapper-two-columns').find('.popup.' + popup),

                    top = $this.offset().top + $this.find('img').height() - $this.closest('.wrapper-two-columns').offset().top + 13,
                    left = $this.offset().left + ($this.width() / 2) - $this.closest('.wrapper-two-columns').offset().left;


                $(".popup").not(his_popup).fadeOut(300);
                his_popup.parent('.popups').css('top', top + 'px');
                his_popup.find('.top-info').css({'width': $this.width()+'px','left': $this.offset().left - $this.closest('.wrapper-two-columns').offset().left});
                his_popup.fadeIn(300).find('.arrow').css('left', left);
            }

        }
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/personal-bio-popup.es6